// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__E-CIS","filesListContainer":"PosDisputesFiles_filesListContainer__ldc0t","filesButton":"PosDisputesFiles_filesButton__2ETEH"};